require('./myCollect.less')
require('../../app/app');

var i18n = require('i18n');
var util = require('../../app/util');
var pageConfig = window.pageConfig || {};
var pagination = require('../../app/pagination');
var doAjax = require('../topic/ajax');
var wrapper = require('../../app/main.html');
var topicList = require('../../app/topicList.html');
pageConfig.adStr = pageConfig.admin ? i18n('admin') : pageConfig.plateAd ? i18n('plate.admin') : '';


var App = {
  init: function() {
  	if (pageConfig.error) {
  		util.show(pageConfig.error, 'error');
  		return;
  	}
  	
  	pageConfig.login = true;
		$('body').append(wrapper(window.pageConfig));


		var reg = new RegExp(pageConfig.projectName + '\/(.+)\/collect')
		var id = parseInt(location.pathname.match(reg)[1], 10);
		var uid = util.getUid();

		$('.list-title').text((id === uid ? i18n('my.collect.topic') : i18n('his.collect.topic')) + ':')
		var userAgent = window.navigator.userAgent || '';
    if (userAgent.match(/[bB]ot\//)  || userAgent.match('[sS]pider')) {
      return
    }

		pagination(`${pageConfig.projectName}/topic/myCollectList?uid=${id}`, topicList, null, null, {
			showDelete: true,
			isMyself: uid == id
		});


		$('.topic-list').on('click', '.remove-list-item', function (e) {
			e.preventDefault();
			var target = $(e.target);
			var topicId = $(e.target).data('tid');
			var plate = target.data('plate');

			doAjax('collect', {tid: topicId, collect: false, removed: true, plate: plate }, function () {
		    target.closest('li').remove();
		    var collectNum = $('.statistics-list .statistics-num.my-cl');
				var num = parseInt(collectNum.text(), 10) || 0;
				collectNum.text(num - 1);
		  });
		});
  }
}

// Entry
;(function() {
  App.init();
})();









// WEBPACK FOOTER //
// ./src/pages/myCollect/myCollect.js